import classNames from "classnames";
import { useTranslation } from "features/translations";
import {
  Action,
  Container,
  Heading3,
  Heading6,
  Icon,
  NewsItems,
  PopularTags,
} from "shared/components";
import { useCollectedNewsRender } from "shared/hooks";

import styles from "./Content071.module.scss";

export const Content071 = ({ payload }) => {
  const title = payload?.headline ?? "";
  const { t } = useTranslation();

  const {
    feed,
    isCompleted,
    renderNext,
    limit,
    articleCategories,
    activeCategory,
  } = useCollectedNewsRender({
    payload,
    widgetNumber: "071",
  });

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.inner}>
          <div className={styles.content}>
            <div className={styles.top}>
              <Heading3 className={styles.title}>{title}</Heading3>
              <Heading6 className={styles.category} color="grey">
                {activeCategory.title}
              </Heading6>
            </div>
            <div className={styles.blocks}>
              <div className={styles.feed}>
                <NewsItems
                  items={feed}
                  className={styles.items}
                  limit={limit}
                />
                {!isCompleted && (
                  <Action onClick={renderNext} className={styles.more}>
                    <div className={styles.loader}>
                      <div className={classNames(styles["loader-wrapper"])}>
                        {t("lazyRendering")}
                        <Icon className={styles.icon} name="loader" />
                      </div>
                    </div>
                  </Action>
                )}
              </div>
            </div>
          </div>
          <div className={styles["tags-list"]}>
            <PopularTags
              tags={articleCategories}
              activeTag={activeCategory.slug}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content071;
